<template>
    <div class="dataForm">
      <slot name="front"/>
      <el-form
        class="mb-20"
        :ref="el => dataForm[index] = el"
        :model="item"
        label-position="top"
        label-width="100px"
        v-for="(item, index) in fromFieldData"
        :key="index"
        :disabled="formDisabled"
      >
        <div class="form-title">
          <span class="label" :class="item.labelClass">{{item.labelName}}</span>
          <span class="left">{{item.title}}</span>
          <span @click="handleAdd(item)" class="add-icon add-title cursor" v-if="item.type === 2 && !item.formList.length && canAdd" >
            <i class="iconfont icon-tubiao-25"></i>
          </span>
        </div>
        <div v-if="item.type === 1" class="underlineForm">
          <template v-for="(fields, k) in item.formList" :key="k" >
            <el-form-item
              :class="[fields.componentType, { fullWidth: fields.config.width }, { redBorder: fields.config.colorTheme === 1 }, { greenBorder: fields.config.colorTheme === 2 }]"
              :error="fields.rules[0].message"
              :rules="fields.rules"
              :prop="'formList.' + k + '.value'"
              :label="fields.fieldName"
              v-if="handleVisible(fields, item.formList)"
            >
              <FromField :fields="fields" @form-change="handleChange(fields, item.formList)" :id="id"/>
            </el-form-item>
          </template>
        </div>
        <template v-if="item.type === 2" >
          <div v-for="(j, k) in item.formList" :key="k" class="border-container">
            <template v-for="(fields, i) in j.list" :key="i" >
              <el-form-item
                :class="[fields.componentType, { fullWidth: fields.config.width }, { redBorder: fields.config.colorTheme === 1 }, { greenBorder: fields.config.colorTheme === 2 }]"
                :rules="fields.rules"
                :prop="'formList.' + k + '.list.' + i + '.value'"
                :label="fields.fieldName"
                :error="fields.rules[0].message"
                v-if="handleVisible(fields, j.list)"
              >
                <FromField :fields="fields" @form-change="handleChange(fields, j.list)" :id="id" />
              </el-form-item>
            </template>
            <i @click="handleDelete(item.formList, k)" class="delete-icon" v-if="canAdd"/>
            <span @click="handleAdd(item)" class="add-icon cursor add-list" v-if="k === item.formList.length - 1 && canAdd">
              <i class="iconfont icon-tubiao-25"></i>
            </span>
          </div>
        </template>
      </el-form>
    <el-table :data="conractMarketUserList" border style="width: 100%" v-if="conractMarketUserList.length">
      <el-table-column prop="name" label="姓名"/>
      <el-table-column prop="rate" label="比例(单位%)"/>
    </el-table>
    <div class="dialog-footer mt-20" v-if="isShowCloseBtn || isShowSubmitBtn">
      <el-button @click="cancle" v-if="isShowCloseBtn" type="danger">
        {{ t('table.cancel') }}
      </el-button>
      <el-button
        v-if="isShowSubmitBtn"
        type="primary"
        :loading="submitLoading"
        @click="handleSubmit"
      >
        {{ t('table.confirm') }}
      </el-button>
    </div>
  </div>
</template>
<script lang='ts'>
import { defineComponent, reactive, toRefs, ref, nextTick, onMounted, unref, PropType } from 'vue'
import { ElMessage } from 'element-plus'
import { createFormData, updateFormData, getPageList } from '@/apis/Form'

import { ArrayRowsItem } from '@/model/Index'
import { FormDataModel } from '@/model/FormModel'
import FromField from '@/components/common/FormField.vue'

import { cloneDeep } from 'lodash'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  components: { FromField },
  props: {
    id: { type: Number, required: true },
    initFormData: { type: Array as PropType<Array<FormDataModel>>, required: true },
    fromFieldData: { type: Array as PropType<Array<FormDataModel>>, required: true },
    dialogFormVisible: { type: Boolean, required: true },
    api: { type: String, required: true },
    handleResolveTempData: { type: Function, required: false },
    isShowCloseBtn: { type: Boolean, required: false, default: true },
    isShowSubmitBtn: { type: Boolean, required: false, default: true },
    formDisabled: { type: Boolean, required: false, default: false },

    submitParams: { type: Object, required: false, default: () => {} },
    commandState: { type: String, required: false },
    method: { type: String, required: false },
    canAdd: { type: Boolean, required: false, default: true }
  },
  emits: ['update:visibel', 'submit'],

  setup(props, context) {
    const { t } = useI18n()
    const dataForm = ref([])

    const dataMap = reactive({
      fromFieldData: props.fromFieldData,
      submitLoading: false,
      deleteList: [] as ArrayRowsItem,
      conractMarketUserList: [] as ArrayRowsItem,
      handleChange(fields: any, formList: any) {
        // 业务模块的单独逻辑
        if (fields.value && fields.fieldKey === 'outsourceCompanyId') {
          formList.forEach((formItem: any) => {
            if (formItem.fieldKey === 'outsourceCompanyContactId') {
              // 外包公司联动外包客户联系人，默认选择第一个
              formItem.config.params.outsourceCompanyId = fields.value
              getPageList('outsourceCompanyContact/page', {
                outsourceCompanyId: fields.value,
                page: 1,
                size: 1000
              }).then((res: any) => {
                formItem.option = res.data || []
                formItem.value = formItem.option[0] ? formItem.option[0].id : ''
              })
            }
          })
        } else if (fields.config.uniqueFieldKey === 'businessType' && fields.value) {
          formList.forEach((formItem: any) => {
            switch (formItem.fieldKey) {
              case 'outsourceCompanyId':
              case 'outsourceCompanyContactId':
              case 'businessClassId':
              case 'engineerIds':
              case 'repairType':
              case 'urgentId':
              case 'fault':
                formItem.rules[0].required = true
                formItem.config.isHide = false
            }
          })
          switch (fields.value) {
            case 1:
            case 3:
              formList.forEach((formItem: any) => {
                if (formItem.fieldKey === 'businessClassId' || formItem.fieldKey === 'engineerIds' || formItem.fieldKey === 'repairType') {
                  formItem.rules[0].required = true
                  formItem.config.isHide = false
                } else if (formItem.fieldKey === 'outsourceCompanyId' || formItem.fieldKey === 'outsourceCompanyContactId') {
                  formItem.rules[0].required = false
                  formItem.config.isHide = true
                  formItem.value = ''
                }
              })
              break
            case 2:
              formList.forEach((formItem: any) => {
                if (formItem.fieldKey === 'repairType' || formItem.fieldKey === 'engineerIds') {
                  formItem.rules[0].required = true
                  formItem.config.isHide = false
                } else if (['businessClassId', 'outsourceCompanyId', 'outsourceCompanyContactId'].includes(formItem.fieldKey)) {
                  formItem.rules[0].required = false
                  formItem.config.isHide = true
                  formItem.value = ''
                }
              })
              break
            case 4:
              formList.forEach((formItem: any) => {
                if (formItem.fieldKey === 'outsourceCompanyId' || formItem.fieldKey === 'outsourceCompanyContactId' || formItem.fieldKey === 'repairType') {
                  formItem.rules[0].required = true
                  formItem.config.isHide = false
                } else if (formItem.fieldKey === 'businessClassId' || formItem.fieldKey === 'engineerIds') {
                  formItem.rules[0].required = false
                  formItem.config.isHide = true
                  formItem.value = ''
                  if (formItem.fieldKey === 'engineerIds') {
                    formItem.value = []
                  }
                }
              })
              break
            case 5:
              formList.forEach((formItem: any) => {
                switch (formItem.fieldKey) {
                  case 'outsourceCompanyId':
                  case 'outsourceCompanyContactId':
                  case 'businessClassId':
                  case 'engineerIds':
                  case 'repairType':
                  case 'urgentId':
                  case 'fault':
                    formItem.rules[0].required = false
                    formItem.config.isHide = true
                    formItem.value = ''
                    if (formItem.fieldKey === 'engineerIds') {
                      formItem.value = []
                    }
                }
              })
          }
        } else if (fields.fieldKey === 'customerCompanyId') {
          if (fields.value) {
            const selectItem = fields.option.filter((item: any) => {
              return item.id === fields.value
            })[0]
            if (!selectItem) {
              return
            }
            const {
              salesManId,
              salesMan
            } = selectItem

            formList.forEach((formItem: any) => {
              if (formItem.fieldKey === 'customerContactIds' || formItem.fieldKey === 'customerCompanyContactId') {
                const isMultiple = formItem.config.multiple
                if (formItem.config.customerCompanyId && formItem.config.customerCompanyId !== fields.value) {
                  formItem.value = ''
                  formItem.option = []
                }
                formItem.config.customerCompanyId = fields.value
                formItem.config.params = {
                  companyId: fields.value
                }

                const _url = formItem.config.url
                const params = {
                  page: 1,
                  size: 1000,
                  companyId: fields.value
                }
                getPageList(_url, params).then((res: any) => {
                  formItem.option = res || []
                  if (formItem.option && formItem.option.length) {
                    formItem.value = isMultiple ? [formItem.option[0].id] : formItem.option[0].id
                  }
                })
              } else if (formItem.fieldKey === 'salesManId') {
                formItem.option = [{
                  id: salesManId,
                  name: salesMan
                }]
                formItem.value = salesManId
              }
            })
          } else {
            formList.forEach((formItem: any) => {
              if ((formItem.fieldKey === 'customerContactIds' || formItem.fieldKey === 'customerCompanyContactId') && formItem.config.customerCompanyId) {
                formItem.value = ''
                formItem.option = []
              } else if (formItem.fieldKey === 'salesManId') {
                formItem.value = ''
                formItem.option = []
              }
            })
          }
        } else if (fields.fieldKey === 'payType' && fields.config.mode === 'marketFee') {
          // 市场费支付方式选后，回显联系人信息
          const contactItem = formList.find((k: any) => k.fieldKey === 'customerCompanyContactId') || {}
          if (contactItem.value && fields.value) {
            getPageList(`customerCompanyContactPay?contactId=${contactItem.value}`).then((result: any) => {
              const tempAccount = result.filter((k: any) => {
                return k.type === fields.value
              })
              if (tempAccount[0]) {
                formList.forEach((formItem: any) => {
                  if (formItem.fieldKey === 'payee') {
                    formItem.value = tempAccount[0].name
                  } else if (formItem.fieldKey === 'paymentAccount') {
                    formItem.value = tempAccount[0].account
                  }
                })
              }
            })
          } else {
            formList.forEach((formItem: any) => {
              if (formItem.fieldKey === 'payee') {
                formItem.value = ''
              } else if (formItem.fieldKey === 'paymentAccount') {
                formItem.value = ''
              }
            })
          }
        } else if (fields.fieldKey === 'customerContactIds' && fields.config.mode === 'marketUser' && (fields.config.oldValue !== (fields.value && fields.value.join()))) {
          if (fields.value && fields.value.length) {
            const selectList = fields.option.filter((k: any) => {
              return fields.value.includes(k.id) && k.marketUser
            })
            dataMap.conractMarketUserList = selectList
          } else {
            dataMap.conractMarketUserList = []
          }
          fields.config.oldValue = fields.value || fields.value.join()
        } else if (fields.config.uniqueFieldKey === 'outsourceCorporate' && fields.value) {
          if (fields.value === 1) {
            formList.forEach((formItem: any) => {
              switch (formItem.fieldKey) {
                case 'name':
                  formItem.fieldName = '公司全称'
                  formItem.config.isHide = false
                  break
                case 'no':
                case 'bank':
                case 'bankNo':
                  formItem.config.isHide = false
                  break
                case 'type':
                  formItem.config.isHide = true
              }
            })
          } else {
            formList.forEach((formItem: any) => {
              switch (formItem.fieldKey) {
                case 'type':
                  formItem.config.isHide = false
                  break
                case 'corporate':
                  formItem.config.isHide = false
                  break
                default:
                  formItem.config.isHide = true
              }
            })
          }
        } else if (fields.config.uniqueFieldKey === 'outsourcePayType' && fields.value) {
          if ([1, 4].includes(fields.value)) {
            formList.forEach((formItem: any) => {
              switch (formItem.fieldKey) {
                case 'corporate':
                case 'type':
                  formItem.config.isHide = false
                  break
                case 'name':
                case 'no':
                case 'bank':
                  formItem.value = ''
                  formItem.config.isHide = true
                  break
                default:
              }
            })
          } else if ([2].includes(fields.value)) {
            formList.forEach((formItem: any) => {
              switch (formItem.fieldKey) {
                case 'name':
                  formItem.fieldName = '账户名'
                  formItem.config.isHide = false
                  break
                case 'no':
                  formItem.fieldName = '账号'
                  formItem.config.isHide = false
                  break
                case 'bank':
                  formItem.config.isHide = true
                  break
              }
            })
          } else if ([3].includes(fields.value)) {
            formList.forEach((formItem: any) => {
              switch (formItem.fieldKey) {
                case 'name':
                  formItem.fieldName = '账户名'
                  formItem.config.isHide = false
                  break
                case 'no':
                  formItem.fieldName = '账号'
                  formItem.config.isHide = false
                  break
                case 'bank':
                  formItem.fieldName = '开户行'
                  formItem.config.isHide = false
                  break
              }
            })
          }
        } else if (['companyConcatPayType', 'companyPayType'].includes(fields.config.uniqueFieldKey) && fields.value) {
          const name = fields.config.uniqueFieldKey === 'companyPayType' ? 'accountName' : 'name'
          if ([1, 4].includes(fields.value)) {
            formList.forEach((formItem: any) => {
              switch (formItem.fieldKey) {
                case name:
                case 'no':
                case 'bank':
                  formItem.value = ''
                  formItem.config.isHide = true
                  break
              }
            })
          } else if ([2].includes(fields.value)) {
            formList.forEach((formItem: any) => {
              switch (formItem.fieldKey) {
                case name:
                  formItem.fieldName = '账户名'
                  formItem.config.isHide = false
                  break
                case 'no':
                  formItem.fieldName = '账号'
                  formItem.config.isHide = false
                  break
                case 'bank':
                  formItem.config.isHide = true
                  break
              }
            })
          } else if ([3].includes(fields.value)) {
            formList.forEach((formItem: any) => {
              switch (formItem.fieldKey) {
                case name:
                  formItem.fieldName = '账户名'
                  formItem.config.isHide = false
                  break
                case 'no':
                  formItem.fieldName = '账号'
                  formItem.config.isHide = false
                  break
                case 'bank':
                  formItem.fieldName = '开户行'
                  formItem.config.isHide = false
                  break
              }
            })
          }
        }
      },
      handleVisible(fields: any) {
        if (!fields.config.isHide) {
          return true
        } else {
          return false
        }
      },
      cancle() {
        context.emit('update:visibel')
      },
      handleAdd(item: any) {
        const temp = props.initFormData.find((k: any) => k.title === item.title)
        const addContion = temp ? temp.formList : null
        const _temp = cloneDeep(addContion && addContion[0])
        item.formList.push(_temp)
        dataMap.clearValidate()
      },
      handleDelete(formList: any, index: number) {
        const row = formList[index]
        if (row.id) {
          dataMap.deleteList.push(row)
        }
        formList.splice(index, 1)
      },
      handleSubmit() {
        const Forms = unref(dataForm)
        const promises = Forms.map((form: any) => {
          return form.validate()
        })
        Promise.all(promises).then(async() => {
          dataMap.submitLoading = true
          try {
            let tempData = dataMap.handleFormData(cloneDeep(dataMap.fromFieldData))
            tempData = Object.assign(tempData, props.submitParams)
            const formSate = (!props.id || props.commandState === 'copy') ? 'add' : 'edit'
            let result = null
            if (formSate === 'add') {
              result = await createFormData(props.api, tempData, props.method)
            } else {
              result = await updateFormData(props.api, props.id, tempData)
            }
            dataMap.submitLoading = false
            context.emit('update:visibel')
            context.emit('submit', result)
            ElMessage({
              message: !props.id ? '创建成功' : props.commandState === 'copy' ? '复制成功' : '编辑成功',
              type: 'success',
              duration: 2000
            })
          } catch (err: any) {
            console.log(err, 'err')
            dataMap.submitLoading = false
            if (err && err.errors) {
              err.errors.forEach((item: any) => {
                dataMap.fromFieldData.forEach((k: any) => {
                  k.formList.forEach((field: any) => {
                    if (field.fieldKey === item.field) {
                      field.rules[0].message = null
                      nextTick(() => {
                        field.rules[0].message = item.defaultMessage
                      })
                    }
                  })
                })
              })
            }
          }
        })
      },
      handleFormData(formData: any) {
        let returnData = {
          deleteList: [] as ArrayRowsItem,
          accounts: [] as ArrayRowsItem
        }
        formData.forEach((k: any) => {
          const _list = [] as ArrayRowsItem
          k.formList.forEach((field: any) => {
            if (k.type === 1) {
              returnData = Object.assign(returnData, dataMap.handleFieldData(field))
            } else if (k.type === 2) {
              const _obj = {
                id: field.id
              }
              const accountsObj = {}

              field.list.forEach((k: any) => {
                if (k.config.submitField === 'accounts') {
                  k.fieldKey = k.fieldKey === 'accountName' ? 'name' : k.fieldKey
                  Object.assign(accountsObj, dataMap.handleFieldData(k))
                } else {
                  Object.assign(_obj, dataMap.handleFieldData(k))
                }
              })

              Object.keys(accountsObj).length && Object.assign(_obj, { accounts: [accountsObj] })
              _list.push(_obj)
              returnData[field.fieldKey] = _list
            }
          })
        })
        // 客户信息新建的账户信息

        // 删除的数据
        const _deleteList = [] as ArrayRowsItem
        dataMap.deleteList.forEach((field: any) => {
          let _obj = {
            id: field.id
          }
          field.list.forEach((k: any) => {
            _obj = Object.assign(_obj, dataMap.handleFieldData(k))
          })
          _deleteList.push(_obj)
        })
        returnData.deleteList = _deleteList

        props.handleResolveTempData && props.handleResolveTempData(returnData)
        return returnData
      },
      handleFieldData(fields: any) {
        if (fields.fieldKey) {
          fields = cloneDeep(fields)
          const returnObj: any = {}
          let val = fields.value
          const isMultiple = Boolean(fields.config?.multiple)
          // 若为非多选组件且值为空数组，转换为 null
          if (!isMultiple && Array.isArray(val) && val.length === 0) {
            val = null
          }
          // 若为以 Id 结尾的外键字段且值为空字符串或空数组，转换为 null
          if (typeof fields.fieldKey === 'string' && fields.fieldKey.endsWith('Id') && (val === '' || (Array.isArray(val) && val.length === 0))) {
            val = null
          }
          returnObj[fields.fieldKey] = val
          return returnObj
        }
      },
      clearValidate() {
        nextTick(() => {
          dataForm.value.forEach((form: any) => {
            form.clearValidate()
          })
        })
      }
    })
    onMounted(() => {
      dataMap.clearValidate()
    })
    return {
      t,
      ...toRefs(dataMap),
      dataForm
    }
  }

})
</script>
